import { render, staticRenderFns } from "./limitPage.vue?vue&type=template&id=2ece0ef6&scoped=true&"
import script from "./limitPage.vue?vue&type=script&lang=js&"
export * from "./limitPage.vue?vue&type=script&lang=js&"
import style0 from "./limitPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./limitPage.vue?vue&type=style&index=1&id=2ece0ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece0ef6",
  null
  
)

export default component.exports